// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 17/02/2023

import { Component } from '@angular/core'
import { BaseController } from './base.controller';

@Component({
	selector: 'ex-vi05',
	template: `<div [id]="getId()" #target><div>`
})

export class ExVi05 extends BaseController {

	constructor() {
		super();
		this.setViewCode('EX_VI05')
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */
	
	
	
	/* -------------------- END CONTROLLER LOGIC ----------------- */

}